import { useMutation } from '@reverbdotcom/commons/src/useMutation';
import { trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { useURL } from '@reverbdotcom/commons/src/url_context';
import { resolveCurrentView } from '@reverbdotcom/commons/src/event_tracking/favorites';
import * as elog from '@reverbdotcom/commons/src/elog';
import { FIND_FAVORITE_PROVIDER_UPSERT_FAVORITE_MUTATION } from '../favorites/favorite_modal';

interface UseAutoSaveFavoriteOptions {
  componentName: string;
  onSuccess?: (savedFavorite: any) => void;
  onError?: (error: Error) => void;
}

export function useAutoSaveFavorite(options: UseAutoSaveFavoriteOptions) {
  const [upsertFavorite] = useMutation(FIND_FAVORITE_PROVIDER_UPSERT_FAVORITE_MUTATION);
  const url = useURL();

  const autoSave = async (queryParams: string) => {
    try {
      const result = await upsertFavorite({
        variables: {
          input: {
            queryParams,
            feedEnabled: true,
            emailEnabled: true,
          },
        },
        refetchQueries: ['Core_FindFavorite'],
        awaitRefetchQueries: true,
      });

      const savedFavorite = result.data?.upsertMyFavorite?.favorite;
      if (savedFavorite) {
        options.onSuccess?.(savedFavorite);

        trackEvent({
          eventName: MParticleEventName.ClickedAddFavoriteSearch,
          addToFeedStatus: true,
          dailyFeedEmailStatus: true,
          currentView: resolveCurrentView(url),
        });
      }

      return result;
    } catch (error) {
      elog.error(
        error.message,
        { componentName: options.componentName, action: 'autoSaveFavorite' },
        error,
      );

      options.onError?.(error);

      throw error;
    }
  };

  return { autoSave };
}
